<div class="card">
  <div class="card-body">
    <wm-assigned-inspections></wm-assigned-inspections>
  </div>
</div>
